import type React from 'react';
import DayPicker, { type DayPickerProps } from 'react-day-picker';

import * as styles from '../util/styles';
import { labels, months, weekdaysLong, weekdaysShort } from '../util/localization';

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const BasePicker: React.FC<DayPickerProps> = (props) => (
  <DayPicker
    {...props}
    /* I18n */
    months={months}
    weekdaysLong={weekdaysLong}
    weekdaysShort={weekdaysShort}
    labels={labels}
    className={`${styles.basePicker} ${props.className}`}
  />
);
